import { z } from 'zod'

import { storeShortWithSupplierSchema } from './stores'

export const chosenBrandSchema = z.object({
  id: z.string(),
  code: z.number().optional(),
  description: z.string().optional(),
  countryId: z.string().optional(),
})

export const chosenCategorySchema = z.object({
  id: z.string(),
  parentId: z.string().optional(),
  code: z.number().optional(),
  description: z.string().optional(),
})

export const chosenCharacteristicSchema = z.object({
  code: z.number(),
  name: z.string().optional(),
  chosenOptions: z.array(z.string()),
})

export const storeShortChosenSchema = storeShortWithSupplierSchema

export const supplierStoresChosenSchema = z.object({
  supplierId: z.string(),
  stores: z.array(storeShortChosenSchema),
})

export const supplierStoresPrioritySchema = supplierStoresChosenSchema.extend({
  priority: z.number(),
})

export const storesFilterChosenSchema = z.object({
  include: z.array(supplierStoresChosenSchema),
  exclude: z.array(supplierStoresChosenSchema),
  priority: z.array(supplierStoresPrioritySchema),
})

export const chosenFiltersSchema = z.object({
  brands: z.array(chosenBrandSchema),
  categories: z.array(chosenCategorySchema),
  characteristics: z.array(chosenCharacteristicSchema),
  stores: storesFilterChosenSchema,
})
